import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { MsalService } from '@azure/msal-angular';
import { DemonstrativoQuitacao } from '../shared/models/demonstrativo-quitacao.model';

@Injectable({
  providedIn: 'root'
})
export class DemonstrativoQuitacaoService {

  private apiUrl = environment.apiPortalPais;

  constructor(private http: HttpClient) { }

  baixarDemonstrativo(dados: any) {
    return this.http.post(`${this.apiUrl}/api/cliente/demonstrativo-quitacao-debitos`, dados, { responseType: 'text' });
  }

}
